import React from 'react';
import { observer } from 'mobx-react';
import debounce from 'lodash/debounce';
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { Select, MultiSelect } from 'components/Select';
import { Input } from 'components/Input';
import { SearchInput } from 'components/SearchInput';
import { Pagination } from 'components/Pagination';
import AgenciesFilter from './AgenciesFilter';
import AgenciesItem from './AgenciesItem';
import pageStore from 'stores/Page/Agencies/AgenciesPageStore';

import * as api from 'Api';
import * as utils from 'Utils';
import * as constants from 'Constants';
import './styles.scss';



@observer
class Agencies extends React.Component {
  constructor (props) {
    super(props);
  }

  componentDidMount() {
    let fieldsData = {
      'paramPage': this.props.qs.page,
      'paramKeyword': this.props.qs.keyword,
      'paramMinPrice': this.props.qs.min_price,
      'paramMaxPrice': this.props.qs.max_price,
      'paramCountries': this.parseCommaSeparatedQs(this.props.qs.countries),
      'paramLanguages': this.parseCommaSeparatedQs(this.props.qs.languages),
      'paramSpecialities': this.parseCommaSeparatedQs(this.props.qs.specialities),
      'paramPlatforms': this.parseCommaSeparatedQs(this.props.qs.platforms),
    }

    pageStore.setFields(fieldsData);
    this.refresh();
  }

  parseCommaSeparatedQs = (values) => {
    let arr = [];
    if (values) arr = values.split(",");
    return arr;
  };

  refresh = debounce(() => {
    const successCallback = (response) => {
      pageStore.deserializeRefresh(response);
    }

    const errorCallback = (errors) => {
      console.error(errors);
    };

    const qs = pageStore.params;
    api.getViewAgencies(successCallback, errorCallback, qs);
  }, 200);

  getBaseUrl = () => {
    return utils.currentURLWithoutParams();
  };

  getUrl = () => {
    const params = pageStore.params;
    let qs = utils.parseQueryString(window.location.search);
    qs = {...qs, ...params};
    return utils.appendQueryString(this.getBaseUrl(), qs);
  };

  handleFilter = (filterData) => {
   pageStore.setFields(filterData);
   this.refresh();

    if (history.replaceState) {
       history.replaceState({}, null, this.getUrl());
    }
  };

  handlePaginate = (val) => {
    this.handleFilter({'paramPage': val});
    const agenciesEl = document.querySelector('.agencies');
    agenciesEl.scrollTop = 0;
  };

  handleKeywordFilter = (val) => {
    this.handleFilter({'paramKeyword': val});
  };

  getNoRecordExistsComponent = () => {
    return (
      <div className="empty-results">
        <div className="empty-results-title">No results found after filtering</div>
      </div>
    );
  };

  getRecordExistsComponent = () => {
    return (
      <div>
        <div className="agencies-items">
          {pageStore.agencies.map((agency) =>
            <AgenciesItem
              key={uniqueId()}
              agency={agency}
            />
          )}
        </div>

        <Pagination
          currentPage={pageStore.currentPage}
          numPages={pageStore.numPages}
          numRecords={pageStore.numRecords}
          handlePaginate={this.handlePaginate}
          baseUrl={this.getBaseUrl()}
          displaySinglePage={true}
          scrollTop={false}
        />
      </div>
    );
  };

  render() {
    return (
      <div className="agencies">
        <AgenciesFilter
          handleKeywordFilter={this.handleKeywordFilter}
          handleFilter={this.handleFilter}
        />

        <div className="agencies-content">
          {pageStore.agencies.length > 0 ? (
            this.getRecordExistsComponent()
          ) : this.getNoRecordExistsComponent()}
        </div>
      </div>
    );
  }
}



export default Agencies;
